import {
  LinesheetsTomorrowCrewOrBrandGuard,
  PriceManagementTomorrowCrewGuard,
  ProductAttributesTomorrowCrewOrBrandGuard,
  PurchaseOrdersTomorrowCrewOrBrandGuard,
  PriceSetupTomorrowCrewGuard,
  UserIsInDBGuard,
  CustomerIsInDBGuard,
  CompanyHashIsValid,
  UserIsBrandOrTomorrowCrew,
  LinesheetSettingsTomorrowCrewGuard,
  ClientManagementTomorrowCrewGuard,
  BookingSystemTomorrowCrewGuard,
  InboundProcessGuard,
  AssetsGuard,
  CourierInboundProcessGuard,
  SuppliersGuard,
  InvestedBrandContactGuard,
} from "src/guards/role-based-guard";

// Linesheets Guard - Userg Group: Brand + Tomorrow Crew + Permissions
export const withLinesheetsGuard = (Component) => (props) =>
  (
    <LinesheetsTomorrowCrewOrBrandGuard>
      <Component {...props} />
    </LinesheetsTomorrowCrewOrBrandGuard>
  );

// Price Management Guard - User Group: Tomorrow Crew
export const withPriceManagementGuard = (Component) => (props) =>
  (
    <PriceManagementTomorrowCrewGuard>
      <Component {...props} />
    </PriceManagementTomorrowCrewGuard>
  );

// Product Attributes Guard - User Group: Brand + Tomorrow Crew + Permissions
export const withProductAttributesGuard = (Component) => (props) =>
  (
    <ProductAttributesTomorrowCrewOrBrandGuard>
      <Component {...props} />
    </ProductAttributesTomorrowCrewOrBrandGuard>
  );

// Purchase Orders Guard - User Group: Brand + Tomorrow Crew + Permissions
export const withPurchaseOrdersGuard = (Component) => (props) =>
  (
    <PurchaseOrdersTomorrowCrewOrBrandGuard>
      <Component {...props} />
    </PurchaseOrdersTomorrowCrewOrBrandGuard>
  );

// Price Setup Guard - User Group: Tomorrow Crew + Permissions
export const withPriceSetupGuard = (Component) => (props) =>
  (
    <PriceSetupTomorrowCrewGuard>
      <Component {...props} />
    </PriceSetupTomorrowCrewGuard>
  );

// Linesheet Settings Guard - User Group: Tomorrow Crew + Permissions
export const withLinesheetSettingsGuard = (Component) => (props) =>
  (
    <LinesheetSettingsTomorrowCrewGuard>
      <Component {...props} />
    </LinesheetSettingsTomorrowCrewGuard>
  );

// Client Management Guard - User Group: Tomorrow Crew + Permissions
export const withClientManagementGuard = (Component) => (props) =>
  (
    <ClientManagementTomorrowCrewGuard>
      <Component {...props} />
    </ClientManagementTomorrowCrewGuard>
  );

// Linesheet Settings Guard - User Group: Tomorrow Crew + Permissions
export const withBookingSystemGuard = (Component) => (props) =>
  (
    <BookingSystemTomorrowCrewGuard>
      <Component {...props} />
    </BookingSystemTomorrowCrewGuard>
  );

export const withUserIsInDBRoleGuard = (Component) => (props) => {
  return (
    <UserIsInDBGuard>
      <Component {...props} />
    </UserIsInDBGuard>
  );
};

export const withCustomerGuard = (Component) => (props) => {
  return (
    <CustomerIsInDBGuard>
      <Component {...props} />
    </CustomerIsInDBGuard>
  );
};

export const withCompanyHashGuard = (Component) => (props) => {
  return (
    <CompanyHashIsValid>
      <Component {...props} />
    </CompanyHashIsValid>
  );
};

export const withBrandOrTomorrowCrewGuard = (Component) => (props) => {
  return (
    <UserIsBrandOrTomorrowCrew>
      <Component {...props} />
    </UserIsBrandOrTomorrowCrew>
  );
};

export const withInboundProcessGuard = (Component) => (props) =>
  (
    <InboundProcessGuard inboundType={props.inboundType}>
      <Component {...props} />
    </InboundProcessGuard>
  );

export const withAssetsGuard = (Component) => (props) =>
  (
    <AssetsGuard>
      <Component {...props} />
    </AssetsGuard>
  );

export const withCourierInboundProcessGuard = (Component) => (props) =>
  (
    <CourierInboundProcessGuard>
      <Component {...props} />
    </CourierInboundProcessGuard>
  );

export const withSuppliersGuard = (Component) => (props) =>
  (
    <SuppliersGuard>
      <Component {...props} />
    </SuppliersGuard>
  );

export const withToleranceGuard = (Component) => (props) =>
  (
    <InvestedBrandContactGuard>
      <Component {...props} />
    </InvestedBrandContactGuard>
  );
